(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["knepper-youtube"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.knepper-yt__link').forEach(function (link) {
  link.addEventListener('click', function (e) {
    var id = link.dataset.videoId;
    if (!id) return;
    e.preventDefault();
    var iframe = document.createElement('iframe');
    iframe.className = 'knepper-yt__iframe';
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = link.getAttribute('aria-label') || 'YouTube-Video';
    link.replaceChildren(iframe);
    link.removeAttribute('href');
    link.classList.add('knepper-yt__link--active');
  }, { once: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
